import React, { useState } from "react";
import "./keyValueBox.css";
import { MdOutlineContentCopy } from "react-icons/md";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

export default function KeyValueBox({ showCopyButton = true, value, label, hideContent = true }) {
    const [showKey, setShowKey] = useState(!hideContent);

    const toggleShowKey = () => setShowKey((prev) => !prev);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(value).catch(() => {
            // alert("Failed to copy API key.");
        });
    };

    return (
        <div className="key_value_box_int">
            <span className="key_value_box_int_label">{label}</span>

            <div className="key_value_box_int_value">
                {showKey ? value : "••••••••••••••••••••"}

                <div className="key_value_box_buttons">
                    <div className="key_value_box_int_value_with_buttons">
                        {showCopyButton && (
                            <button onClick={copyToClipboard} className="key_value_box_button">
                                <MdOutlineContentCopy className="copy_icon" />
                            </button>
                        )}
                        {hideContent && (
                            <button onClick={toggleShowKey} className="key_value_box_button">
                                {showKey ? <FaRegEyeSlash className="copy_icon" /> : <FaRegEye className="copy_icon" />}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}